import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-outer d-flex justify-content-center align-items center w-100 h-100'>
      <div className="footer-inner d-flex justify-content-center align-items center w-100 h-100">
        <div className="footer-upper">
            <div className="footer-left">
                <h4 className='secondary-header'><Link to='/'>LIMS HOTEL MANAGEMENT INSTITUTE</Link></h4>
                <p className='paragraph-text'><strong>Address:</strong> Sister, Nivedita Rd, Ward 2, Pradhan Nagar, Siliguri, District - Darjeeling, West Bengal 734003</p>
                <p className="paragraph-text"><strong>Phone:</strong> +91 8016096293/4</p>
            </div>
            <div className="footer-right">
                <Link to='/' className="cta-text">Home</Link>
                <Link to='/courses' className="cta-text">Courses</Link>
                <Link to='/contact' className="cta-text">Contact</Link>
            </div>
        </div>
        <div className="footer-lower">
            <h3 className='secondary-header'>We help you with your dreams</h3>
            <p className="cta-text">developed by <Link to='https://www.koadai.com'>KOADAI</Link></p>
        </div>
      </div>
    </div>
  )
}

export default Footer
